// This icon file is generated automatically.
var BothCaretFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M4.22 7.61l5.23-5.39c.29-.3.81-.3 1.1 0l5.23 5.4c.4.4.24 1.05-.37 1.05H4.59c-.61 0-.77-.64-.37-1.06zm0 4.78c-.4-.42-.24-1.06.37-1.06h10.82c.61 0 .77.64.37 1.06l-5.23 5.39c-.29.3-.81.3-1.1 0l-5.23-5.4z" } }] }, "name": "both-caret", "theme": "filled" };
export default BothCaretFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/BothCaretFilled.js
// module id = 2113
// module chunks = 0